var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskFailedIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 197,
    viewBox: "0 0 223 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5170_2976",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 193,
    height: 197
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5104",
    d: "M71 196.5L39 176.5L0 22.5L159.5 0L192.5 183L71 196.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5170_2976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 5102",
    filter: "url(#filter0_d_5170_2976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3076L19.5074 32.565C15.4588 33.0692 12.6976 36.915 13.5141 40.9123L44.202 191.145C44.9343 194.731 48.3044 197.147 51.9349 196.69L173.07 181.436C177.09 180.929 179.842 177.127 179.066 173.15L149.751 22.9133C149.047 19.3022 145.667 16.8528 142.016 17.3076Z",
    fill: "url(#paint0_linear_5170_2976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3076L19.5074 32.565C15.4588 33.0692 12.6976 36.915 13.5141 40.9123L44.202 191.145C44.9343 194.731 48.3044 197.147 51.9349 196.69L173.07 181.436C177.09 180.929 179.842 177.127 179.066 173.15L149.751 22.9133C149.047 19.3022 145.667 16.8528 142.016 17.3076Z",
    stroke: "white"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5103",
    d: "M67.5 194L41.5 178L57.4875 174.909C61.4424 174.145 65.225 176.868 65.7552 180.861L67.5 194Z",
    fill: "#C7D2F6",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5107",
    d: "M38 60.5L122 49.5",
    stroke: "url(#paint1_linear_5170_2976)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5108",
    d: "M44 85.5L139.5 72.5",
    stroke: "url(#paint2_linear_5170_2976)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5110",
    d: "M50 107.5L126 97.5",
    stroke: "url(#paint3_linear_5170_2976)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter1_d_5170_2976)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.429 111.5C199.861 111.5 218.857 96.7254 218.857 78.5C218.857 60.2746 199.861 45.5 176.429 45.5C152.996 45.5 134 60.2746 134 78.5C134 87.0448 138.176 94.8311 145.026 100.692L140.286 111.5L152.059 105.517C158.955 109.287 167.359 111.5 176.429 111.5Z",
    fill: "#4C95FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M172.428 83.6172C172.454 84.4323 172.834 85.2064 173.487 85.7748C174.141 86.3432 175.016 86.6612 175.928 86.6612C176.839 86.6612 177.715 86.3432 178.368 85.7748C179.022 85.2064 179.402 84.4323 179.428 83.6172V63.544C179.402 62.7289 179.022 61.9548 178.368 61.3864C177.715 60.818 176.839 60.5 175.928 60.5C175.016 60.5 174.141 60.818 173.487 61.3864C172.834 61.9548 172.454 62.7289 172.428 63.544V83.6172ZM172.428 92.3687C172.428 94.0909 174.003 95.5 175.928 95.5C177.853 95.5 179.428 94.0909 179.428 92.3687C179.428 90.6464 177.853 89.2373 175.928 89.2373C175.001 89.2406 174.113 89.5716 173.457 90.1581C172.801 90.7446 172.431 91.5392 172.428 92.3687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5170_2976",
    x: 8.87061,
    y: 12.7534,
    width: 174.827,
    height: 188.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_2976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_2976",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5170_2976",
    x: 130,
    y: 43.5,
    width: 92.8569,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_2976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_2976",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5170_2976",
    x1: 96.25,
    y1: 16.5,
    x2: 96.25,
    y2: 197.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5170_2976",
    x1: 146,
    y1: 48,
    x2: 38.5,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5170_2976",
    x1: 150,
    y1: 72.5,
    x2: 44,
    y2: 85.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5170_2976",
    x1: 140,
    y1: 90,
    x2: 46,
    y2: 102.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskFailedIllustration);
export default __webpack_public_path__ + "static/media/taskFailedIllustration.84b806b403f4994f60d28a0497f524ae.svg";
export { ForwardRef as ReactComponent };